// extracted by css-extract-rspack-plugin
export default {"colorTextInformation":"#0660da","urlHighlight":"url-highlight-message__urlHighlight___Od_an"};